"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServerError = function ServerError(props) {
  var children = props.children,
      message = props.data.message;

  return _react2.default.createElement(
    "div",
    { className: "erg-components-ServerError erg-margin-15 text-danger" },
    _react2.default.createElement(
      "h2",
      { className: "text-danger" },
      "Server Error"
    ),
    children ? children : _react2.default.createElement(
      "p",
      null,
      message
    )
  );
};

ServerError.displayName = "ServerError";

ServerError.defaultProps = {
  data: {}
};

ServerError.propTypes = {
  children: _propTypes2.default.node,
  data: _propTypes2.default.shape({
    message: _propTypes2.default.string // eslint-disable-line react/no-unused-prop-types
  })
};

exports.default = ServerError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/ServerError.js
 ** module id = 392
 ** module chunks = 0
 **/